import React from 'react';
import { FormattedMessage } from 'react-intl';
import constants from './constants'

const InvalidFeedbackString = (InvalidStringID, fieldNameID = "", className = "")  => { 
  // console.log("InvalidFeedbackString", InvalidStringID, fieldNameID, className)
  return (
    <div className={"invalid-feedback " + className}>
      {InvalidStringID !== "" && <FormattedMessage id={InvalidStringID} />}
      {InvalidStringID === "EMPTY_FIELD_ERROR" && fieldNameID !== "" ? <FormattedMessage id={fieldNameID} /> : ""} 
    </div>
  )
}

/**
 * Closes the modal 
 * @param {*} modalId - id of the modal to be closed 
 */
const closeModal = (modalId) => {
  console.log("closing modal common fn", modalId);
  const modalElement = document.getElementById(modalId);

  if (modalElement) {
    // Find the close button within the modal and simulate a click
    const closeButton = modalElement.querySelector('.btn-close, [data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.click(); // Trigger the close button click to hide the modal properly
    } else {
      // Fallback: manually hide the modal if close button is not found
      modalElement.classList.remove('show');
      modalElement.setAttribute('aria-hidden', 'true');
      modalElement.style.display = 'none';

      // Remove backdrop manually
      const backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.parentNode.removeChild(backdrop);
      }

      // Reset body state
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
    }
  }
};


/**
 * Formats the string to escape special characters
 * @param {*} str - string to be escaped
 * @returns 
 */
const formatTextForDisplay = (str) => {
  if (!str) return null;

  // Replace literal double-backslashes with single backslashes to handle escape sequences
  const escapedString = str
    .replace(/\\\\/g, '\\')  // Converts \\ to \
    .replace(/\\r/g, '\r')   // Converts \r to carriage return
    .replace(/\\n/g, '\n')   // Converts \n to newline
    .replace(/\\t/g, '\t')   // Converts \t to tab
    .replace(/\\"/g, '"')    // Converts \" to "
    .replace(/\\'/g, "'");   // Converts \' to '

  // Now process the string to render it with JSX while preserving the formatting
  return escapedString.split('\n').map((line, index) => (
    <React.Fragment key={index}>
      {/* Handle spaces and tabs */}
      {line.split('').map((char, i) => {
        if (char === '\t') {
          // Render tabs as multiple non-breaking spaces
          return <span key={i}>&nbsp;&nbsp;&nbsp;&nbsp;</span>;
        } else if (char === ' ') {
          // Render each space as a non-breaking space
          return <span key={i}>&nbsp;</span>;
        } else {
          return <React.Fragment key={i}>{char}</React.Fragment>;
        }
      })}
      {index < escapedString.split('\n').length - 1 && <br />}
    </React.Fragment>
  ));
};

/**
 * 
 * @param {*} roles 
 * @returns rolesSorted
 */
function getRolesSort(roles){
  if(!roles || (roles && roles.length <= 0)) return [];
  const orderMap={};
  (constants.rolesIdsSort).forEach((role, index)=>{
    orderMap[role] = index;
  });
  let rolesSorted = roles.sort((a, b) => {
    const orderA = orderMap.hasOwnProperty(a.id) ? orderMap[a.id] : Infinity;
    const orderB = orderMap.hasOwnProperty(b.id) ? orderMap[b.id] : Infinity;
    return orderA - orderB;
  });
  return rolesSorted;
}

/**
 * Sort users by lastName, firstName, and email
 * @param {Array} users - Array of user objects
 * @returns {Array} usersSorted - Sorted array of users
 */
function getUsersSort(users) {
  if (!users || (users && users.length <= 0)) return [];
  
  // Sort users by lastName, then firstName, then email
  let usersSorted = [...users].sort((a, b) => {
    // First sort by lastName
    if (a.lastName && b.lastName) {
      const lastNameComparison = a.lastName.localeCompare(b.lastName);
      if (lastNameComparison !== 0) {
        return lastNameComparison;
      }
    } else if (a.lastName) {
      return -1; // a has lastName, b doesn't
    } else if (b.lastName) {
      return 1;  // b has lastName, a doesn't
    }
    
    // If lastNames are equal, sort by firstName
    if (a.firstName && b.firstName) {
      const firstNameComparison = a.firstName.localeCompare(b.firstName);
      if (firstNameComparison !== 0) {
        return firstNameComparison;
      }
    } else if (a.firstName) {
      return -1; // a has firstName, b doesn't
    } else if (b.firstName) {
      return 1;  // b has firstName, a doesn't
    }
    
    // If both lastNames and firstNames are equal, sort by email
    if (a.email && b.email) {
      return a.email.localeCompare(b.email);
    } else if (a.email) {
      return -1; // a has email, b doesn't
    } else if (b.email) {
      return 1;  // b has email, a doesn't
    }
    
    // If all are missing or equal, maintain original order
    return 0;
  });
  
  return usersSorted;
}

/**
 * Handles shift-click selection for checkboxes in tables and lists
 * @param {Array} items - Array of all selectable items
 * @param {Array} selectedItems - Array of currently selected item IDs
 * @param {string} clickedItemId - ID of the item that was just clicked
 * @param {string} lastClickedItemId - ID of the previously clicked item
 * @returns {Array} - New array of selected item IDs
 */
function handleShiftClickSelection(items, selectedItems, clickedItemId, lastClickedItemId) {
  console.log('handleShiftClickSelection', items, selectedItems, clickedItemId, lastClickedItemId)
  
  if (!items || !items.length || !clickedItemId || !lastClickedItemId) {
    return selectedItems;
  }

  // Find indices of clicked items
  const itemIds = items.map(item => item.id);
  const clickedIndex = itemIds.indexOf(clickedItemId);
  const lastClickedIndex = itemIds.indexOf(lastClickedItemId);
  
  if (clickedIndex === -1 || lastClickedIndex === -1) {
    return selectedItems;
  }

  // Determine the selection range
  const start = Math.min(lastClickedIndex, clickedIndex);
  const end = Math.max(lastClickedIndex, clickedIndex);
  
  // Get the IDs of all items in the range
  const rangeIds = itemIds.slice(start, end + 1);
  
  // Create a new selection array based on the current selection
  const newSelection = [...selectedItems];
  
  // Check if the clicked item is already selected
  const isSelected = selectedItems.includes(clickedItemId);
  
  // Apply the same selection state to all items in the range
  rangeIds.forEach(id => {
    const idIndex = newSelection.indexOf(id);
    if (isSelected) {
      // If the clicked item is selected, remove all items in range
      if (idIndex !== -1) {
        newSelection.splice(idIndex, 1);
      }
    } else {
      // If the clicked item is not selected, add all items in range
      if (idIndex === -1) {
        newSelection.push(id);
      }
    }
  });
  
  return newSelection;
}

/**
 * Processes and saves the user's hide column preferences
 * @param {string} tableKey - The unique key for the table
 * @param {Object} user - The user object
 * @param {Array} columns - The array of all columns
 * @param {Array} cols - The array of visible column IDs
 * @param {Object} props - The component props
 * @param {Function} setUserState - The function to update the user state
 */
function processHideColumnPreferences(tableKey, user, columns, cols, props, setUserState) {
  // If no tableKey is provided, we won't save preferences
  if (!tableKey) return;
  
  const preferences = {...user.preferences};
  const hiddenColumns = columns.filter(column => !cols.includes(column.id)).map(column => column.id);
  preferences.hiddenColumns = {...preferences.hiddenColumns, [tableKey]: hiddenColumns};
  props.dispatch(setUserState({...user, preferences}));
}

/**
 * Recursively cleans an object by removing properties with null, undefined, empty string, empty array, or empty object values.
 * @param {Object} obj - The object to be cleaned
 * @returns {Object|null} - The cleaned object or null if all properties are removed
 */
function cleanObject(obj) {
  // If the input is not an object or is null, return it as is
  if (obj === null || typeof obj !== 'object') return obj;

  const isPlainObject = (obj) => Object.prototype.toString.call(obj) === '[object Object]';
  if (!isPlainObject(obj)) return obj;

  const result = {};
  let hasProps = false;
  // Iterate over each property in the object
  for (const key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      const value = obj[key];
      let cleaned;

      // Check if the value is an object or array and clean it recursively
      if (value && typeof value === 'object' && isPlainObject(value)) {
        cleaned = cleanObject(value);
      } else if (value && Array.isArray(value)) {
        if (value.length === 0) {
          cleaned = null;
        } else {
          cleaned = value.map(item => cleanObject(item)).filter(item => item !== null);
          if (cleaned.length === 0) cleaned = null;
        }
      } else {
        cleaned = value;
      }

      if (cleaned !== null) {
        result[key] = cleaned;
        hasProps = true;
      }
    }
  }

  return hasProps ? result : null;
}

const commonFunctions = {
  InvalidFeedbackString,
  closeModal,
  formatTextForDisplay,
  getRolesSort,
  getUsersSort,
  handleShiftClickSelection,
  processHideColumnPreferences,
  cleanObject
}

export default commonFunctions;